import React, {useState} from 'react';
import {
  Alert,
  Button,
  Link,
  Modal,
  Space,
  Tooltip,
  Message,
} from '@bedrock/components';
import { Bell } from '@bedrock/icons-react';
import classNames from 'classnames/bind';
import styles from './index.less';
import POPOChatIcon from '#features/POPOChatIcon';
import { biddingReminder, demandReminder, trumpetCommonSendRemainder, closedLoopCommonSendRemainder, UserSimpleVo, kpiAdjustmentSendRemainder, ipCooperationReminderSendRemainder } from '#services/api';
import moment from 'moment';

const cx = classNames.bind(styles);

function Operator(props: {
  useList: UserSimpleVo[];
  row: any;
  remindState: any;
  id: number;
  notifyOperateUser?: any;
  journal_type?: string;
  notify_operate_user_list?: any;
  hideRemind?: boolean,
}) {
  const {
    useList,
    row,
    remindState: { can_remind, state_notify_record },
    id,
    journal_type,
    hideRemind = false,
  } = props;
  const [stateNotify, setStateNotify] = useState({});
  const [visible, setVisible] = React.useState(false);
  const getRemindTime = (modify: any) => {
    if (modify) {
      const { updated_at } = modify;
      const countdown = 60 - moment().diff(moment(updated_at), 'minute');
      return countdown > 0 ? countdown : 1;
    } else {
      return 0;
    }
  };
  const userListFn = () => {
    if (!useList.length) return false
    if (useList && useList.length < 3) {
      const userNameStr = useList.map((user) => user.name).join('、');
      return <div className={cx('ellipsis')}>{userNameStr}</div>;
    } else {
      const userNameStr = useList.map((user) => user.name).join('、');
      return (
        <>
          <div className={cx('ellipsis')}>{useList[0].name + '...'}</div>
          <Tooltip
            title={userNameStr}
            style={{
              maxWidth: 200,
            }}
          >
            <div className={cx('conventionalTest')}>更多</div>
          </Tooltip>
        </>
      );
    }
  };

  const showPOPOChatIcon = () => {
    if (useList?.length > 1) {
      return (
        <Tooltip title={'点击发起POPO对话'}>
          <POPOChatIcon
            ssid={""}
            clickFlag
            onClick={() => {
              setVisible(true);
            }}
          />
        </Tooltip>
      )
    }
    if (useList?.length === 1 && useList[0]?.email && useList[0]?.email !== "mpc@service.netease.com") {
      return <POPOChatIcon ssid={useList[0]?.email} />
    }
    return null;
  }

  const asyncHandleRemind = () => {
    switch (journal_type) {
      case 'demand':
        return demandReminder({ id });
      case 'bidding':
        return biddingReminder({ id });
      case 'trumpet_demand':
        return trumpetCommonSendRemainder({ id });
      case 'closed_loop_demand':
        return closedLoopCommonSendRemainder({ id });
      case 'demand_kpi_adjustment_order':
        return kpiAdjustmentSendRemainder({ id });
      case 'ip_cooperation_demand':
        return ipCooperationReminderSendRemainder({ id });
      default:
        return trumpetCommonSendRemainder({ id })
    }
  }

  return (
    <>
      <Space size={4}>
        {userListFn()}
        {showPOPOChatIcon()}
        {/* {useList?.length > 1 ? (
          <Tooltip title={'点击发起POPO对话'}>
            <POPOChatIcon
              ssid={""}
              clickFlag
              onClick={() => {
                setVisible(true);
              }}
            />
          </Tooltip>
        ) : (
          <POPOChatIcon ssid={useList[0]?.email} />
        )} */}

        {row?.is_current && !!useList?.length && !hideRemind &&
          (stateNotify?.notify_id || !can_remind ? (
            <Tooltip
              title={`${getRemindTime(
                stateNotify || state_notify_record
              )}分钟后可再次提醒`}
              style={{
                maxWidth: 200,
              }}
            >
              <Button icon={<Bell />} type="link" disabled>
                提醒
              </Button>
            </Tooltip>
          ) : (
            <Button
              icon={<Bell />}
              type="link"
              disabled={!can_remind || stateNotify?.notify_id}
              onClick={() => {
                Modal.confirm({
                  status: 'info',
                  title: '确定发送POPO服务号提醒消息给相关操作人员吗？',
                  zIndex: 2000,
                  onOk() {
                    return asyncHandleRemind().then((res) => {
                      if (res?.code === 1) {
                        setStateNotify(res?.data?.state_notify);
                        Message.success(res?.message);
                      }
                    }).catch((err) => {
                      console.log(err);
                    });
                  },
                });
              }}
            >
              提醒
            </Button>
          ))}
      </Space>
      <Modal
        title="POPO对话"
        visible={visible}
        width={480}
        okButton={false}
        cancelButton={false}
        onCancel={() => setVisible(false)}
        zIndex={2000}
        renderFooter={null}
      >
        <div className={cx('modal-content-title')}>
          请选择需要 POPO 对话的人员
        </div>
        {useList?.map((item) => {
          if (item?.email === 'mpc@service.netease.com' || item?.is_external) {
            return <div className={cx('modal-user-item')} key={item?.id}>{item?.name}</div>
          }
          return (
            <div className={cx('modal-user-item')} key={item?.id}>
              {`${item?.name}(${item?.email})`}  <POPOChatIcon ssid={item?.email} />
            </div>
          )
        })}

        <Alert
          className={cx('modal-alert')}
          type="info"
          message={
            <div>
              <div>若无法打开POPO对话窗口，请升级客户端版本。</div>
              <div>
                <span>升级地址：</span>
                <Link
                  type="primary"
                  href="http://popo.netease.com"
                  target="_blank"
                >
                  http://popo.netease.com
                </Link>
              </div>
            </div>
          }
        />
      </Modal>
    </>
  );
}
export default Operator;
